module.exports = __webpack_public_path__ + "img/icon_help.ce27bdf0.png";